import type { DocMigration } from "../docMigration";
import { forEachRoom } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_19: DocMigration = {
  maxSchemaVersion: "0.0.19",
  apply(json: any) {
    forEachRoom(json, (room) => {
      if (room.layout && room.layout.linework) {
        for (const linework of room.layout.linework) {
          if (linework.planType !== undefined) {
            if (linework.planType === "FOUNDATION") {
              linework.addToFloorPlan = false;
              linework.addToElectricalPlan = false;
              linework.addToFoundationPlan = true;
              linework.addToPlumbingPlan = false;
              linework.addToMechanicalPlan = false;
            } else if (linework.planType === "FLOOR") {
              linework.addToFloorPlan = true;
              linework.addToElectricalPlan = true;
              linework.addToFoundationPlan = false;
              linework.addToPlumbingPlan = false;
              linework.addToMechanicalPlan = false;
            }
            delete linework.planType;
          } else {
            linework.addToFloorPlan = true;
            linework.addToElectricalPlan = true;
            linework.addToFoundationPlan = false;
            linework.addToPlumbingPlan = false;
            linework.addToMechanicalPlan = false;
          }
        }
      }
    });

    return json;
  },
};

export default migration_0_0_19;
